import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class NominasFiniquitoEscenarioComponent {
  idProyecto
  idColaborador
  idFiniquito
  idEscenario
}

module.component('nominasFiniquitoEscenario', {
  controller: NominasFiniquitoEscenarioComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    idFiniquito: '<',
    idEscenario: '<',
  },
});



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/component.js